import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FindSuccessItem, Images, useModal} from 'utils';
import {CustomizedSwitch, NewCard, SimpleTooltip} from 'components';
import {systemItemStyles} from './styles';
import {httpRequestsOnSuccessActions, systemActions} from 'store';
import {ConnectTherapyLake} from './modals';
import {clearHouseTypeEnums, DISCONNECT_INTEGRATION_ACTION_TYPE, EDIT_INTEGRATION_ACTION_TYPE} from './constants';

export const Therapy = () => {
    const tlClearinghouse = useSelector((state) => state.system.systemIntegrations)?.tlClearinghouse;
    const classes = systemItemStyles();
    const {open} = useModal();
    const dispatch = useDispatch();
    const success = FindSuccessItem(EDIT_INTEGRATION_ACTION_TYPE);
    const successDisconnect = FindSuccessItem(DISCONNECT_INTEGRATION_ACTION_TYPE);
    const [connect, setConnect] = useState(false);
    const [claimStatusCheckEnabled, setClaimStatusCheckEnabled] = useState(false);
    const [automationPaymentEnabled, setAutomationPaymentEnabled] = useState(false);

    const resetDefaultValues = () => {
        setConnect(tlClearinghouse?.isActive);
        setClaimStatusCheckEnabled(!!tlClearinghouse?.claimStatusCheckEnabled);
        setAutomationPaymentEnabled(!!tlClearinghouse?.automationPaymentEnabled);
    };

    useEffect(() => {
        if (tlClearinghouse?.id) {
            resetDefaultValues();
        }
    }, [tlClearinghouse]);

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(EDIT_INTEGRATION_ACTION_TYPE));
        }
        if (successDisconnect) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(DISCONNECT_INTEGRATION_ACTION_TYPE));
        }
    }, [success, successDisconnect]);

    const handleToggleFeature = (field, currentValue) => {
        const newValue = !currentValue;
        if (field === 'claimStatusCheckEnabled') setClaimStatusCheckEnabled(newValue);
        if (field === 'automationPaymentEnabled') setAutomationPaymentEnabled(newValue);
        dispatch(
            systemActions.editIntegration({
                tlClearinghouse: {[field]: newValue},
                clearinghouseType: clearHouseTypeEnums.TL_CLEARINGHOUSE,
            })
        );
    };

    const handleSetCalendarStatus = () => {
        setConnect(!connect);
        dispatch(systemActions.disconnectIntegration(!connect, clearHouseTypeEnums.TL_CLEARINGHOUSE));
    };

    return (
        <div className="office-ally-box">
            <div className="space-between" style={{padding: 16, borderBottom: '1px solid #E4E7EC'}}>
                <div className="flex-align-center" style={{gap: '4px'}}>
                    <div className={classes.iconAndTitle}>
                        <img src={Images.logoSmall} alt="officeAlly"/>
                        <p>TL Clearinghouse</p>
                    </div>
                    <NewCard/>
                </div>
                {tlClearinghouse?.id ? (
                    <div className={classes.iconAndTitle} style={{gap: 16, height: 32}}>
                        {/*{!editTlClearinghouse &&*/}
                        {/*    <EditWithIcon handleClick={() => setEditTlClearinghouse(!editTlClearinghouse)} />*/}
                        {/*}*/}
                        <SimpleTooltip title={<p>{'Disconnect Office Ally'}</p>} placement="top-start">
                            <CustomizedSwitch checked={connect} handleClick={handleSetCalendarStatus}/>
                        </SimpleTooltip>
                    </div>
                ) : (
                    <button onClick={() => open(<ConnectTherapyLake/>)} className={classes.connectBtn}>
                        Connect
                    </button>
                )}
            </div>

            {tlClearinghouse?.id && connect && (
                <div style={{padding: '16px'}}>

                    <div className='automation-features-box'>
                        <img src={Images.infoCircle} alt="incoIcon"/>
                        <p>Automation features provided by this connection.</p>
                    </div>


                    <div className="tl-clearinghouse-status-box" >
                        <div className="tl-clearinghouse-text-box">
                            <p style={{fontWeight: 600, marginBottom: 4}}>Claim Status Check (276/277)</p>
                            <p style={{color: '#5E6C84', marginBottom: 2}}>Check payer-reported claim status from the Claims workspace.</p>
                            <p style={{color: '#7A869A'}}>Claim status checking is hidden and unavailable until enabled.</p>
                        </div>

                        <CustomizedSwitch
                            checked={claimStatusCheckEnabled}
                            handleClick={() => handleToggleFeature('claimStatusCheckEnabled', claimStatusCheckEnabled)}
                        />
                    </div>

                    <div className="tl-clearinghouse-status-box" >
                        <div className="tl-clearinghouse-text-box">
                            <p style={{fontWeight: 600, marginBottom: 4}}>Automation Payment (ERA 835)</p>
                            <p style={{color: '#5E6C84', marginBottom: 2}}>ERA files are retrieved automatically and payments are created and applied.</p>
                            <p style={{color: '#7A869A'}}>While disabled, the automated payment flow does not run.</p>
                        </div>

                        <CustomizedSwitch
                            checked={automationPaymentEnabled}
                            handleClick={() => handleToggleFeature('automationPaymentEnabled', automationPaymentEnabled)}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
